import { FC, useCallback } from "react";
import { useUser } from "@hooks/useUser";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { useCompleteWorkspaceOnboardingMutation } from "@api/userOnboarding.api";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useRemoveUnonboardedOrganizationsMutation } from "@api/organization.api";
import { BaseOnboardingContainer } from "../components/BaseOnboardingContainer";
import { PrimaryFlow } from "../flows/PrimaryFlow";
import { usePrimaryEntity } from "../usePrimaryEntity";

export const OnboardingContainer: FC = () => {
    const activeWorkspace = useActiveWorkspace();
    const user = useUser();
    const primaryEntity = usePrimaryEntity();
    const completeWorkspaceOnboardingMutation =
        useCompleteWorkspaceOnboardingMutation();
    const navigate = useStateAwareNavigate();
    const removeUnonboardedOrganizationsMutation =
        useRemoveUnonboardedOrganizationsMutation();

    const onFinish = useCallback(async () => {
        if (!activeWorkspace) {
            return;
        }

        await completeWorkspaceOnboardingMutation.mutateAsync(
            activeWorkspace.id,
        );

        await removeUnonboardedOrganizationsMutation.mutateAsync();

        navigate("/");
    }, [
        activeWorkspace,
        completeWorkspaceOnboardingMutation,
        navigate,
        removeUnonboardedOrganizationsMutation,
    ]);

    if (!user || !activeWorkspace || !primaryEntity) {
        return null;
    }

    return (
        <BaseOnboardingContainer logoutButtonSize="lg">
            <PrimaryFlow entity={primaryEntity} onFinish={onFinish} />
        </BaseOnboardingContainer>
    );
};
